<template>
  <div class="card hover-animation cursor-default" :class="mobileWidth">
    <div class="flex gap-4 items-center justify-center text-sm">
      <span class="flex gap-3 items-center" test-id="currency-icon">
        <currency-icon
          :currency="getCurrencyCountry(rate.from)"
          size="h-6 w-6"
        />
        {{ rate.from || '' }}
      </span>
      <swap-currency-icon />
      <span class="flex gap-3 items-center" test-id="currency-icon">
        <currency-icon :currency="getCurrencyCountry(rate.to)" size="h-6 w-6" />
        {{ rate.to || '' }}
      </span>
    </div>

    <div
      class="flex justify-between items-center mt-7 text-sm pb-3 border-b border-border-color"
    >
      <span class="font-normal text-gray-muted">Exchange Rate</span>
      <span class="font-semibold">{{ rate.exchange_rate || '' }}</span>
    </div>
  </div>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import { GetCurrencyCountry } from '@/utils/helpers'

export default {
  name: 'ExchangeRateCard',
  props: {
    rate: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    SwapCurrencyIcon: () => import('@/assets/v2/icons/SwapCurrencyIcon.vue'),
    CurrencyIcon: () => import('@/assets/icons/CurrencyIcons.vue')
  },
  data () {
    return {
      breakpoints
    }
  },
  computed: {
    mobileWidth () {
      return breakpoints.mdAndDown
        ? 'w-full p-4'
        : breakpoints.lgAndDown
        ? 'w-302px p-6'
        : 'w-338px p-6'
    }
  },
  methods: {
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  height: 150px;
  border-radius: 8px;
  background-color: white;
  margin-bottom: 32px;
}
</style>
